import { TaskTemplateServiceTemplateQuery } from "../../../graphql-types";
import { isLink } from "../../shared/types/link";
import { pp } from "../../shared/utilities/pretty-print";
import { HeaderNavProps } from "../HeaderNav.stories";

export function selectHeaderNavProps(
  data: TaskTemplateServiceTemplateQuery
): Partial<HeaderNavProps> {
  if (data.taskTemplateServicePage?.serviceIndexPath == null) {
    throw Error(
      `data.taskTemplateServicePage?.serviceIndexPath is null: ${pp({
        data,
      })}`
    );
  }
  if (!data.taskTemplateServicePage?.serviceLinks?.every(isLink)) {
    throw Error(
      `data.taskTemplateServicePage?.serviceLinks?.[x] is not a Link: ${pp({
        data,
      })}`
    );
  }

  return {
    servicesLinks: data.taskTemplateServicePage.serviceLinks,
    serviceIndexPath: data.taskTemplateServicePage.serviceIndexPath,
  };
}
